<mat-card class="invoice-payments">
  <div class="invoice-payments__header">
    <div class="invoice-payments__id">ID: {{ internId }}</div>
    <div class="invoice-payments__name">Name: {{ internName }}</div>
  </div>

  <mat-tab-group class="invoice-payments__tabs">
    <mat-tab label="Open Invoices">
      @if (openInvoices) {
        <app-open-invoices class="invoice-payments__tab-body"
          [invoices]="openInvoices"
          [internId]="internId"
          (selectedInvoiceRecordNo)="onSelectedInvoiceRecordNoChange($event)"
          >
        </app-open-invoices>
      } @else {
        <div class="invoice-payments__spinner">
          <mat-spinner diameter="80"></mat-spinner>
        </div>
      }
    </mat-tab>
    <mat-tab label="Paid Invoices">
      @if (paidInvoices) {
        <app-paid-invoices class="invoice-payments__tab-body"
          [invoices]="paidInvoices"
          (selectedInvoiceRecordNo)="onSelectedInvoiceRecordNoChange($event)">
        </app-paid-invoices>
      } @else {
        <div class="invoice-payments__spinner">
          <mat-spinner diameter="80"></mat-spinner>
        </div>
      }
    </mat-tab>
  </mat-tab-group>
  @if (loadingPdf) {
    <div class="spinner-container">
      <mat-spinner class="spinner"></mat-spinner>
    </div>
  }
</mat-card>


